import { AuthDictionary } from '@src/scripts/auth'
import { documentUrl, srcUrl } from '@src/scripts/config'
import { StoreType } from "@src/scripts/type"

const list = [
  {
    name: '首页',
    icon: 'HomeOutlined',
    path: '/store'
  },
  {
    name: '商户管理',
    icon: 'ShopOutlined',
    path: '/storeManager',
    roles: [StoreType.Linkage]
  },
  {
    name: '商品管理',
    icon: 'GoldOutlined',
    path: '/good',
    children: [
      {
        name: '商品列表',
        icon: 'BarsOutlined',
        path: '/good'
      },
      {
        name: '商品库存',
        icon: 'CarryOutOutlined',
        path: '/stock',
        roles: [StoreType.Normal],
      }
    ]
  },
  {
    name: '堂食订单',
    icon: 'FileOutlined',
    path: '/order'
  },
  {
    name: '店内管理',
    icon: 'GoldOutlined',
    path: '/store',
    roles: [StoreType.Normal],
    children: [
      {
        name: '打印机管理',
        icon: 'PrinterOutlined',
        path: '/printer'
      },
      {
        name: '餐台管理',
        icon: 'ShopOutlined',
        path: '/desk',
        auth: [AuthDictionary.updateDesk]
      },
      {
        name: '员工管理',
        icon: 'TeamOutlined',
        path: '/staff',
        auth: [AuthDictionary.updateStaff]
      }
    ]
  },
  {
    name: '外卖管理',
    icon: 'GoldOutlined',
    path: '/outOrder',
    children: [
      {
        name: '外卖订单',
        icon: 'FileOutlined',
        path: '/outOrder'
      },
      {
        name: '外卖评价',
        icon: 'CommentOutlined',
        path: '/comment'
      },
      {
        name: '外卖活动',
        icon: 'RiseOutlined',
        path: '/storeActivity',
        auth: [AuthDictionary.manager]
      },
    ]
  },
  {
    name: '商城管理',
    icon: 'ShoppingOutlined',
    children: [
      {
        name: '商城商品',
        icon: 'TableOutlined',
        path: '/mall/good',
        roles: [StoreType.Linkage],
      },
      {
        name: '商城订单',
        icon: 'FileOutlined',
        path: '/mall/order'
      },
    ]
  },
  {
    name: '平台管理',
    icon: 'LaptopOutlined',
    children: [
      {
        name: '京东商品映射',
        icon: 'CopyOutlined',
        path: '/platform/jdMapping',
      },
      {
        name: '京东订单',
        icon: 'FileOutlined',
        path: '/platform/jdOrder',
      },
    ]
  },
  {
    name: '营业统计',
    icon: 'FileOutlined',
    path: '/businessStatistic',
    roles: [StoreType.Linkage]
  },
  {
    name: '报表',
    icon: 'FundViewOutlined',
    children: [
      {
        name: '订单统计',
        icon: 'FileOutlined',
        path: '/report/order'
      },
      {
        name: '商品销售统计',
        icon: 'OneToOneOutlined',
        path: '/report/good'
      },
      {
        name: '厨师统计',
        icon: 'OneToOneOutlined',
        path: '/report/cook'
      },
      {
        name: '档口统计',
        icon: 'OneToOneOutlined',
        path: '/report/stall'
      },
      {
        name: '收银员统计',
        icon: 'OneToOneOutlined',
        path: '/report/cashier'
      },
      {
        name: '退菜统计',
        icon: 'OneToOneOutlined',
        path: '/report/orderGoodCancelStatistic'
      },
    ]
  },
  {
    name: '外卖报表',
    icon: 'FundViewOutlined',
    children: [
      {
        name: '外卖订单统计',
        icon: 'FileOutlined',
        path: '/report/outOrder'
      },
      {
        name: '外卖商品销售统计',
        icon: 'OneToOneOutlined',
        path: '/report/outGood'
      },
      {
        name: '外卖厨师统计',
        icon: 'OneToOneOutlined',
        path: '/report/outCook'
      },
      {
        name: '外卖档口统计',
        icon: 'OneToOneOutlined',
        path: '/report/outStall'
      },
      {
        name: '退菜统计',
        icon: 'OneToOneOutlined',
        path: '/report/outOrderGoodCancelStatistic'
      },
    ]
  },
  {
    name: '商城报表',
    icon: 'FundViewOutlined',
    children: [
      {
        name: '商城订单统计',
        icon: 'FileOutlined',
        path: '/report/mallOrder'
      },
      {
        name: '商城商品销售统计',
        icon: 'OneToOneOutlined',
        path: '/report/mallGood'
      }
    ]
  },
  {
    name: '积分商城',
    icon: 'ShoppingOutlined',
    path: '/marketing',
    roles: [StoreType.Linkage]
  },
  // {
  //   name: '物料管理',
  //   icon: 'ReconciliationOutlined',
  //   path: '/material',
  //   roles: [StoreType.Linkage]
  // },
  {
    name: '会员中心',
    icon: 'UserOutlined',
    path: '/member'
  },
  {
    name: '日志',
    icon: 'BugOutlined',
    path: '/log',
    auth: [AuthDictionary.logger]
  },
  {
    name: '基础数据维护',
    icon: 'GlobalOutlined',
    path: '/basicData',
    auth: [AuthDictionary.updateBaseInfo]
  },
  {
    name: '系统信息',
    icon: 'FundViewOutlined',
    children: [
      {
        name: '文档',
        icon: 'FileWordOutlined',
        path: 'link-document',
        link: documentUrl,
      },
      {
        name: 'API服务下载',
        icon: 'DownloadOutlined',
        path: 'link-api',
        link: srcUrl + '/download/api/jiandanmao-service.exe',
      },
      {
        name: '收银台下载',
        icon: 'DownloadOutlined',
        path: 'link-cashier',
        link: srcUrl + '/download/client/jiandanmao-cashier.exe',
      },
    ]
  },
] as SystemMenu[]

// 递归读取菜单
function filter(menus: SystemMenu[], storeType: StoreType) {
  let arr = menus.filter(a => !a.roles || a.roles.length === 0 || a.roles.indexOf(storeType) > -1)
  arr = arr.filter(a => {
    if (!a.auth || a.auth.length === 0) return true
    return a.auth.filter(b => $util.hasAuth(b)).length > 0
  })
  arr.forEach(menu => {
    if (!menu.children || menu.children.length === 0) return
    menu.children = filter(menu.children, storeType)
  })
  return arr
}

/**
 * 根据商户类型获取菜单
 * @param storeType 商户类型
 * @returns 
 */
export const getMenus = (storeType: StoreType) => filter(list, storeType)
